import http from '@/http'

export async function deleteDraftSheet (imageId: any): Promise<any> {
  const { data } = await http.delete(`/admin/draft-sheets/${imageId}`)
  return data
}
